import { GameModeEnum, Product, ProductType } from "./types";

const createProduct = (
  id: number,
  title: string,
  thumbnailUrl: string,
  shortDescription: string,
  type: ProductType,
  attributes: Product["attributes"]
): Product => {
  return { id, title, thumbnailUrl, shortDescription, type, attributes };
};

export const products: Product[] = [
  createProduct(
    1,
    "WTB", // Who's The Bot
    "/img/img_hiddenai.jpeg",
    "",
    ProductType.RECREATION,
    {
      minUsers: 4,
      maxUsers: 20,
      gameModes: [GameModeEnum.individual],
      isCooperative: false,
    }
  ),
  createProduct(
    0,
    "J2H", // Journey to Hometown
    "/img/img_j2h.jpeg",
    "",
    ProductType.RECREATION,
    {
      minUsers: 6,
      maxUsers: 20,
      gameModes: [GameModeEnum.team, GameModeEnum.individual],
      isCooperative: true,
    }
  ),
  createProduct(
    6,
    "Dealerjack",
    "/img/img_dealerjack.jpeg",
    "",
    ProductType.RECREATION,
    {
      minUsers: 2,
      maxUsers: 8,
      gameModes: [GameModeEnum.individual],
      isCooperative: false,
    }
  ),
  createProduct(
    7,
    "Quiz",
    "/img/img_quiz.jpeg",
    "quizDescription",
    ProductType.TOOL,
    {
      minUsers: 2,
      maxUsers: 30,
    }
  ),

  createProduct(
    2,
    "RoleDistributor",
    "/img/img_roulette.jpeg",
    "roleRouletteDescription",
    ProductType.TOOL,
    {
      minUsers: 4,
      maxUsers: 30,
      features: {
        privateChat: true,
      },
    }
  ),

  createProduct(
    3,
    "SingleRoleRoulette",
    "/img/img_roulette_single.jpeg",
    "singleRoleRouletteDescription",
    ProductType.TOOL,
    {
      minUsers: 1,
      maxUsers: 1,
    }
  ),

  createProduct(
    4,
    "TeamBuilder",
    "/img/img_team_builder.jpeg",
    "teamBuilderDescription",
    ProductType.TOOL,
    {
      minUsers: 1,
      maxUsers: 1,
    }
  ),

  createProduct(
    5,
    "LuckyDraw",
    "/img/img_luckydraw.jpeg",
    "luckyDrawDescription",
    ProductType.TOOL,
    {
      minUsers: 1,
      maxUsers: 1,
    }
  ),

  // 임시 숨김
  // createProduct(
  //   8,
  //   "FightSimulator",
  //   "/img/img_fight_simulator.jpeg",
  //   "fightSimulatorDescription",
  //   ProductType.TOOL,
  //   {
  //     minUsers: 1,
  //     maxUsers: 1,
  //   }
  // ),

  // createProduct(
  //   7,
  //   "BattleJack",
  //   "/img/img_battlejack.jpeg",
  //   "battlejackDescription",
  //   ProductType.RECREATION,
  //   {
  //     minUsers: 2,
  //     maxUsers: 8,
  //     gameModes: [GameModeEnum.individual],
  //     isCooperative: false,
  //   }
  // ),
];

// 기존 코드와의 호환성을 위한 함수들
export const getRecreations = () =>
  products.filter((p) => p.type === ProductType.RECREATION);

export const getTools = () =>
  products.filter((p) => p.type === ProductType.TOOL);
